import React from 'react';
import { ErrorMessage, useField } from 'formik';
import MaskedInput from 'react-text-mask';

function ValidatedMaskedField(props) {
    let { className } = props;
    const { name, label, placeholder, mask, readOnly, errors, touched, onChange } = props;

    className = className || "form-control";
    let showError = errors[name] && touched[name];
    if (showError) {
        className += " is-invalid";
    }
    
    const [field] = useField(Object.assign({}, props, { name: name }, { className: className }));
    const randomAutoComplete = Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
    return (
        <div className="form-group">
            {label && <label htmlFor={name}>{label}</label>}
            <MaskedInput id={name} name={name} mask={mask} type="text" placeholder={placeholder} readOnly={readOnly} className={className} autoComplete={randomAutoComplete} {...field} onChange={onChange ? e => onChange(e, field, props.values, props.setValues) : field.onChange} />
            <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
    )
}

export default ValidatedMaskedField;
